import styled from '@emotion/styled';

export const MainBlock = styled.div`
  margin: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
